import React from 'react';
import { Button } from '@mui/material';

function MUICancelButton(props) {
    const { variant = 'outlined', title, disabled ,sx, ...restProps } = props;
    return (
        <Button variant={variant}
            {...restProps}
            disableElevation
            disabled={disabled}
            size="small"
            sx={[{
                backgroundColor: '#fff', color: '#000000', minWidth: '80px', textTransform: 'none',
                fontWeight: 550, borderColor: '#D5D7DA', color: '#414651', borderRadius: '8px',
                height: '38px', fontSize: '12px',
                "&:disabled": {
                    backgroundColor: "lightBlack",
                    color: "#a2a2a2",
                    cursor: "not-allowed",
                    pointerEvents: "auto"
                },
            }, { ...sx }]}>
            {title}
        </Button>
    )
};

export default MUICancelButton;
